import React from 'react';
import MobileFooter from "../../components/Footer/MobileFooter";
import SectionAside from "../../components/SectionAside";

export default function () {
    return (
        <section className="section-form">
            <div className="section__outer">

                <SectionAside/>

                <div className="section__content">
                    <div className="section__content-inner">
                        <div className="section__entry">
                            <h2 className="section__content-title">Thank you for sharing more about yourself!</h2>
                            <p>We're excited to co-create the future of The Room with you.</p>
                            <p>Please check your inbox for an email from our founder, Fred Swaniker, on next steps and
                                more details on what it means to be a member of The Room.</p>
                        </div>

                        <MobileFooter/>
                    </div>
                </div>
            </div>
        </section>
    );
}